import React from 'react';
import { Trans } from 'react-i18next';

interface ContentHeaderProps {
  color: string;
  i18nKey: string;
}

export const ContentWrapper: React.FC<ContentHeaderProps> = ({ color, i18nKey }) => {
  return (
    <span style={{ color: color }}>
      <Trans i18nKey={i18nKey} />
    </span>
  );
};
